(function () {
  'use strict';

  var STORAGE_KEY = 'otb_wishlist_v1';
  var wishlist = [];
  var lastFocus = null;
  var qvOpen = false;
  var wishOpen = false;

  function qs(sel, el) {
    return (el || document).querySelector(sel);
  }

  function qsa(sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel));
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isAvailableFlag(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      wishlist = Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      wishlist = [];
    }
    wishlist = wishlist.map(function (item) {
      if (!item || typeof item !== 'object') return item;
      return Object.assign({}, item, {
        available: isAvailableFlag(item.available),
        onSale: isAvailableFlag(item.onSale) || !!item.compare
      });
    });
    return wishlist;
  }

  function writeWishlist() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
    } catch (err) {
      /* ignore quota / private mode */
    }
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { items: wishlist.slice() } })
    );
    syncWishlistUI();
  }

  function findWishIndex(id) {
    var sid = String(id);
    for (var i = 0; i < wishlist.length; i++) {
      if (String(wishlist[i].id) === sid) return i;
    }
    return -1;
  }

  function isWished(id) {
    return findWishIndex(id) !== -1;
  }

  function productFromCard(card) {
    if (!card) return null;
    return {
      id: card.getAttribute('data-product-id'),
      variantId: card.getAttribute('data-variant-id'),
      handle: card.getAttribute('data-product-handle'),
      url: card.getAttribute('data-product-url'),
      title: card.getAttribute('data-product-title'),
      price: card.getAttribute('data-product-price'),
      compare: card.getAttribute('data-product-compare') || '',
      type: card.getAttribute('data-product-type') || '',
      available: isAvailableFlag(card.getAttribute('data-product-available')),
      onSale: isAvailableFlag(card.getAttribute('data-product-on-sale')),
      image: card.getAttribute('data-product-image') || '',
      description: card.getAttribute('data-product-description') || ''
    };
  }

  function liveAvailability(id) {
    if (!id) return null;
    var card = qs(
      '[data-product-card][data-product-id="' + String(id).replace(/"/g, '') + '"]'
    );
    if (!card) return null;
    return isAvailableFlag(card.getAttribute('data-product-available'));
  }

  function toggleWishlist(product) {
    if (!product || !product.id) return;
    var idx = findWishIndex(product.id);
    if (idx === -1) {
      wishlist.unshift({
        id: String(product.id),
        variantId: product.variantId || '',
        handle: product.handle || '',
        url: product.url || '',
        title: product.title || '',
        price: product.price || '',
        compare: product.compare || '',
        type: product.type || '',
        available: isAvailableFlag(product.available),
        onSale: !!(isAvailableFlag(product.onSale) || product.compare),
        image: product.image || ''
      });
      toast('Saved to wishlist');
    } else {
      wishlist.splice(idx, 1);
      toast('Removed from wishlist');
    }
    writeWishlist();
  }

  function removeWishlist(id) {
    var idx = findWishIndex(id);
    if (idx === -1) return;
    wishlist.splice(idx, 1);
    writeWishlist();
  }

  function syncWishlistUI() {
    var count = wishlist.length;
    qsa('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    qsa('[data-wishlist-open]').forEach(function (el) {
      el.setAttribute('aria-label', 'Wishlist — ' + count + ' saved');
      el.classList.toggle('has-items', count > 0);
    });
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var on = isWished(id);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var title = btn.closest('[data-product-card]');
      var name = title ? title.getAttribute('data-product-title') || 'product' : 'product';
      btn.setAttribute(
        'aria-label',
        (on ? 'Remove ' : 'Save ') + name + (on ? ' from wishlist' : ' to wishlist')
      );
    });
    renderWishlistDrawer();
  }

  function renderWishlistDrawer() {
    var list = qs('[data-wishlist-list]');
    if (!list) return;
    var empty = qs('[data-wishlist-empty]', list);

    qsa('[data-wishlist-item]', list).forEach(function (node) {
      node.remove();
    });

    if (!wishlist.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    wishlist.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'wish-drawer__item';
      article.setAttribute('data-wishlist-item', '');
      article.setAttribute('data-product-id', item.id);

      var mediaHtml = item.image
        ? '<img src="' + escapeAttr(item.image) + '" alt="" loading="lazy" width="120" height="150">'
        : '<span class="wish-drawer__ph"></span>';

      var live = liveAvailability(item.id);
      var available = live === null ? isAvailableFlag(item.available) : live;
      if (live !== null && live !== isAvailableFlag(item.available)) {
        item.available = live;
      }

      var onSale = !!(isAvailableFlag(item.onSale) || item.compare);
      var priceHtml = onSale
        ? '<span class="price-sale">' +
          escapeHtml(item.price || '') +
          '</span><span class="price-compare">' +
          escapeHtml(item.compare || '') +
          '</span>'
        : '<span class="price-regular">' + escapeHtml(item.price || '') + '</span>';
      if (!available) {
        priceHtml += '<span class="wish-drawer__sold">Sold out</span>';
      }

      var actions = '';
      if (available && item.variantId) {
        actions +=
          '<button type="button" class="wish-drawer__add" data-cart-add data-variant-id="' +
          escapeAttr(item.variantId) +
          '" data-available="true">Add to cart</button>';
      } else {
        actions +=
          '<button type="button" class="wish-drawer__sold-btn" disabled aria-disabled="true" data-available="false">Sold out</button>';
      }
      actions +=
        '<button type="button" class="wish-drawer__remove" data-wishlist-remove data-product-id="' +
        escapeAttr(item.id) +
        '">Remove</button>';

      article.innerHTML =
        '<a class="wish-drawer__media" href="' +
        escapeAttr(item.url || '#') +
        '">' +
        mediaHtml +
        '</a>' +
        '<div class="wish-drawer__meta">' +
        '<a class="wish-drawer__name" href="' +
        escapeAttr(item.url || '#') +
        '">' +
        escapeHtml(item.title || 'Product') +
        '</a>' +
        '<div class="wish-drawer__price">' +
        priceHtml +
        '</div>' +
        '<div class="wish-drawer__actions">' +
        actions +
        '</div>' +
        '</div>';

      list.appendChild(article);
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function toast(message) {
    var el = qs('[data-otb-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    el.classList.add('is-visible');
    window.clearTimeout(toast._t);
    toast._t = window.setTimeout(function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () {
        el.hidden = true;
      }, 280);
    }, 2200);
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('otb-modal-open', lock);
    document.body.classList.toggle('otb-modal-open', lock);
  }

  /* —— Wishlist drawer —— */
  function openWishlist() {
    var overlay = qs('[data-wishlist-overlay]');
    var drawer = qs('[data-wishlist-drawer]');
    if (!overlay || !drawer) return;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    wishOpen = true;
    lockScroll(true);
    var closeBtn = qs('[data-wishlist-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function closeWishlist() {
    var overlay = qs('[data-wishlist-overlay]');
    var drawer = qs('[data-wishlist-drawer]');
    if (!overlay || !drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    wishOpen = false;
    if (!qvOpen) lockScroll(false);
    window.setTimeout(function () {
      if (!wishOpen) overlay.hidden = true;
    }, 300);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  /* —— Quick view —— */
  function fillQuickView(product) {
    var root = qs('[data-quick-view-root]');
    if (!root || !product) return;

    var img = qs('[data-qv-image]', root);
    var sold = qs('[data-qv-sold]', root);
    var sale = qs('[data-qv-sale]', root);
    var type = qs('[data-qv-type]', root);
    var title = qs('[data-qv-title]', root);
    var price = qs('[data-qv-price]', root);
    var compare = qs('[data-qv-compare]', root);
    var soldLabel = qs('[data-qv-sold-label]', root);
    var priceWrap = qs('[data-qv-price-wrap]', root);
    var desc = qs('[data-qv-desc]', root);
    var link = qs('[data-qv-link]', root);
    var variant = qs('[data-qv-variant]', root);
    var form = qs('[data-qv-form]', root);
    var unavailable = qs('[data-qv-unavailable]', root);
    var qty = qs('[data-qv-qty]', root);
    var qtyRow = qs('[data-qv-qty-row]', root);
    var addBtn = qs('[data-qv-add]', root);
    var soldBtn = qs('[data-qv-sold-btn]', root);
    var available = isAvailableFlag(product.available);
    var onSale = !!(isAvailableFlag(product.onSale) || product.compare);

    if (img) {
      if (product.image) {
        img.src = product.image;
        img.alt = product.title || '';
        img.hidden = false;
      } else {
        img.removeAttribute('src');
        img.alt = '';
        img.hidden = true;
      }
    }
    if (sold) sold.hidden = available;
    if (sale) {
      sale.hidden = !onSale;
      sale.classList.toggle('qv-sale-stamp--with-sold', onSale && !available);
    }
    if (type) {
      type.textContent = product.type || '';
      type.hidden = !product.type;
    }
    if (title) title.textContent = product.title || '';
    if (price) {
      price.textContent = product.price || '';
      price.classList.toggle('price-sale', onSale);
      price.classList.toggle('price-regular', !onSale);
    }
    if (compare) {
      if (onSale && product.compare) {
        compare.textContent = product.compare;
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }
    if (soldLabel) soldLabel.hidden = available;
    if (priceWrap) priceWrap.classList.toggle('price-sold', !available);
    if (desc) {
      desc.textContent = product.description || '';
      desc.hidden = !product.description;
    }
    if (link) link.href = product.url || '#';
    if (variant) variant.value = available ? product.variantId || '' : '';
    if (qty) {
      qty.value = '1';
      qty.disabled = !available;
    }
    if (qtyRow) qtyRow.hidden = !available;
    if (addBtn) {
      addBtn.hidden = !available;
      addBtn.disabled = !available;
      addBtn.setAttribute('data-available', available ? 'true' : 'false');
    }
    if (soldBtn) {
      soldBtn.hidden = available;
      soldBtn.disabled = true;
    }
    if (form) {
      form.classList.toggle('is-unavailable', !available);
      form.setAttribute('data-available', available ? 'true' : 'false');
      form.setAttribute('aria-disabled', available ? 'false' : 'true');
    }
    if (unavailable) unavailable.hidden = available;
  }

  function openQuickView(product) {
    var root = qs('[data-quick-view-root]');
    var dialog = qs('[data-quick-view-dialog]');
    if (!root || !dialog) return;
    fillQuickView(product);
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    qvOpen = true;
    lockScroll(true);
    dialog.focus();
  }

  function closeQuickView() {
    var root = qs('[data-quick-view-root]');
    if (!root) return;
    root.classList.remove('is-open');
    qvOpen = false;
    if (!wishOpen) lockScroll(false);
    window.setTimeout(function () {
      if (!qvOpen) root.hidden = true;
    }, 280);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  async function addToCart(variantId, quantity) {
    var qty = quantity || 1;
    if (!variantId) throw new Error('Missing variant');

    if (window.OfficialCartDrawer && typeof window.OfficialCartDrawer.add === 'function') {
      await window.OfficialCartDrawer.add(variantId, qty);
      return;
    }

    var res = await fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty }]
      })
    });
    var data = await res.json().catch(function () {
      return null;
    });
    if (!res.ok) {
      throw new Error(
        (data && (data.description || data.message)) || 'Could not add to cart.'
      );
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', { detail: { source: 'product-interactions' } })
    );

    if (window.OfficialCartDrawer && typeof window.OfficialCartDrawer.open === 'function') {
      if (typeof window.OfficialCartDrawer.refresh === 'function') {
        await window.OfficialCartDrawer.refresh(true);
      } else {
        window.OfficialCartDrawer.open();
      }
    } else {
      toast('Added to cart');
      window.setTimeout(function () {
        window.location.href = cartRoot() + 'cart';
      }, 600);
    }
  }

  function canAddFromControl(el) {
    if (!el) return false;
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return false;
    var availableAttr = el.getAttribute('data-available');
    if (availableAttr != null && !isAvailableFlag(availableAttr)) return false;
    var card = el.closest('[data-product-card]');
    if (card && !isAvailableFlag(card.getAttribute('data-product-available'))) return false;
    var form = el.closest('[data-qv-form]');
    if (form && !isAvailableFlag(form.getAttribute('data-available'))) return false;
    return true;
  }

  function onClick(e) {
    var wishToggle = e.target.closest('[data-wishlist-toggle]');
    if (wishToggle) {
      e.preventDefault();
      e.stopPropagation();
      var card = wishToggle.closest('[data-product-card]');
      toggleWishlist(productFromCard(card));
      return;
    }

    var wishOpenBtn = e.target.closest('[data-wishlist-open]');
    if (wishOpenBtn) {
      e.preventDefault();
      openWishlist();
      return;
    }

    var wishClose = e.target.closest('[data-wishlist-close]');
    if (wishClose || e.target.matches('[data-wishlist-overlay]')) {
      if (!(wishClose && wishClose.tagName === 'A' && wishClose.getAttribute('href'))) {
        e.preventDefault();
      }
      closeWishlist();
      return;
    }

    var wishRemove = e.target.closest('[data-wishlist-remove]');
    if (wishRemove) {
      e.preventDefault();
      removeWishlist(wishRemove.getAttribute('data-product-id'));
      return;
    }

    var qvBtn = e.target.closest('[data-quick-view]');
    if (qvBtn) {
      e.preventDefault();
      e.stopPropagation();
      var qvCard = qvBtn.closest('[data-product-card]');
      openQuickView(productFromCard(qvCard));
      return;
    }

    if (e.target.closest('[data-quick-view-close]') || e.target.matches('[data-quick-view-overlay]')) {
      e.preventDefault();
      closeQuickView();
      return;
    }

    var cartAdd = e.target.closest('[data-cart-add]');
    if (cartAdd) {
      if (!canAddFromControl(cartAdd)) {
        e.preventDefault();
        e.stopPropagation();
        toast('This piece is sold out');
        return;
      }
      /* Prefer cart-drawer.js when present; otherwise add here */
      if (!window.OfficialCartDrawer) {
        e.preventDefault();
        e.stopPropagation();
        var vid = cartAdd.getAttribute('data-variant-id');
        if (!vid) return;
        cartAdd.disabled = true;
        addToCart(vid, 1)
          .catch(function (err) {
            window.alert(err.message || 'Could not add to cart.');
          })
          .finally(function () {
            cartAdd.disabled = false;
          });
      } else if (qvOpen) {
        window.setTimeout(closeQuickView, 400);
      }
    }
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-qv-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();

    if (!isAvailableFlag(form.getAttribute('data-available'))) {
      toast('This piece is sold out');
      return;
    }

    var variant = qs('[data-qv-variant]', form);
    var qtyInput = qs('[data-qv-qty]', form);
    var btn = qs('[data-qv-add]', form);
    var variantId = variant && variant.value;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!variantId || (btn && !canAddFromControl(btn))) {
      toast('This piece is sold out');
      return;
    }
    if (btn) btn.disabled = true;
    addToCart(variantId, qty)
      .then(function () {
        closeQuickView();
      })
      .catch(function (err) {
        window.alert(err.message || 'Could not add to cart.');
      })
      .finally(function () {
        if (btn && isAvailableFlag(form.getAttribute('data-available'))) {
          btn.disabled = false;
        }
      });
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    if (qvOpen) {
      e.preventDefault();
      closeQuickView();
      return;
    }
    if (wishOpen) {
      e.preventDefault();
      closeWishlist();
    }
  }

  function init() {
    readWishlist();
    syncWishlistUI();
    document.addEventListener('click', onClick);
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('wishlist:updated', syncWishlistUI);

    window.OfficialWishlist = {
      open: openWishlist,
      close: closeWishlist,
      toggle: toggleWishlist,
      items: function () {
        return wishlist.slice();
      }
    };

    window.OfficialQuickView = {
      open: openQuickView,
      close: closeQuickView
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
